<template>
  <div>
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-blue">
        <div class="card-icon">
          <md-icon>local_offer</md-icon>
        </div>
        <h4 class="title">Discounts</h4>
      </md-card-header>

      <md-card-content>
        <md-toolbar md-elevation="0" class="md-transparent md-dense">
          <div class="md-toolbar-selection-end">
            <md-button
              class="md-icon-button md-dense md-primary md-round"
              @click="onNewDiscount"
            >
              <md-icon>add</md-icon>
              <md-tooltip md-direction="top">Add Discount</md-tooltip>
            </md-button>
          </div>
        </md-toolbar>

        <md-table :value="discounts" @md-selected="onRowSelected">
          <md-table-row
            slot="md-table-row"
            slot-scope="{ item }"
            md-selectable="single"
          >
            <md-table-cell md-label="Code">{{ item.code }}</md-table-cell>

            <md-table-cell md-label="Redemptions">
              {{ item.usage_count }} / {{ item.usage_limit }}
            </md-table-cell>

            <md-table-cell md-label="Status">
              {{ getStatus(item) }}
            </md-table-cell>

            <md-table-cell md-label="Expiry Date">
              {{ item.expiry_date | formatDate }}
            </md-table-cell>

            <md-table-cell class="text-right">
              <md-button
                class="md-just-icon md-simple md-danger"
                @click.stop="onDeleteDiscount(item)"
              >
                <md-icon>delete</md-icon>
                <md-tooltip md-direction="top">Delete</md-tooltip>
              </md-button>

              <md-button
                class="md-just-icon md-simple md-success"
                @click.stop="onViewDiscount(item)"
              >
                <md-icon>visibility</md-icon>
                <md-tooltip md-direction="top">View</md-tooltip>
              </md-button>
            </md-table-cell>
          </md-table-row>

          <md-table-empty-state
            md-label="No Discounts Yet"
            :md-description="`Add a Discount.`"
          >
            <md-button class="md-primary md-raised" @click="onNewDiscount">
              Add Discount
            </md-button>
          </md-table-empty-state>
        </md-table>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import moment from "moment";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "DiscountList",

  computed: {
    ...mapGetters("discount", ["discounts", "selectedDiscount"])
  },

  methods: {
    ...mapActions("discount", [
      "fetchDiscounts",
      "newDiscount",
      "selectDiscount",
      "deleteDiscount"
    ]),

    getStatus(item) {
      return item?.active ? "Active" : "Inactive";
    },

    onNewDiscount() {
      this.newDiscount();
    },

    onViewDiscount(discount) {
      if (!discount) return;
      this.selectDiscount(discount);
    },

    onRowSelected(selection) {
      const item = Array.isArray(selection) ? selection[0] : selection;
      if (!item) return;
      this.onViewDiscount(item);
    },

    async onDeleteDiscount(discount) {
      if (!discount) return;

      await this.deleteDiscount(discount);
    }
  },

  async mounted() {
    await this.fetchDiscounts();
  }
};
</script>
